// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./stimulus_application"

import AlertsController from "./alerts_controller"
application.register("alerts", AlertsController)

import BoothController from "./booth_controller"
application.register("booth", BoothController)

import CashCalcController from "./cash_calc_controller"
application.register("cash-calc", CashCalcController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import InPlaceController from "./in_place_controller"
application.register("in-place", InPlaceController)

import PickupController from "./pickup_controller"
application.register("pickup", PickupController)

import ShiftStatusController from "./shift_status_controller"
application.register("shift-status", ShiftStatusController)

import ShiftUnassignController from "./shift_unassign_controller"
application.register("shift-unassign", ShiftUnassignController)

import StoreFilterController from "./store_filter_controller"
application.register("store-filter", StoreFilterController)

import StripeController from "./stripe_controller"
application.register("stripe", StripeController)

import TicketController from "./ticket_controller"
application.register("ticket", TicketController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)
